import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from 'src/environments/environment';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY, ReCaptchaV3Service } from 'ng-recaptcha';
import { AvlaToastModule } from 'avla-components';
import { TranslateModule, TranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import localeEs from '@angular/common/locales/es';
import localePt from '@angular/common/locales/pt';
import localeUs from '@angular/common/locales/en';
import { registerLocaleData } from '@angular/common';
import { LocationEvaluationInterceptor } from './quote/interceptors/location-evaluation.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { SecurityInterceptor } from './common/interceptor/security.interceptor';
import { appReducers } from './app.reducer';
import { AppComponent } from './app.component';
import { NavigationService } from './quote/services/navigation.service';
import { IndexDBService } from './common/services/indexedDB.service';

registerLocaleData(localeEs, 'cl');
registerLocaleData(localeEs, 'pe');
registerLocaleData(localePt, 'br');
registerLocaleData(localeEs, 'mp');
registerLocaleData(localePt, 'mp-br');
registerLocaleData(localeUs, 'mp-us');
registerLocaleData(localeEs, 'mp-mx');

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function initializeIndexedDB(indexDB: IndexDBService) {
  return () => indexDB.ensureInitialized();
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    StoreModule.forRoot(appReducers),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
    }),
    AvlaToastModule,
    RecaptchaV3Module,
    TranslateModule,
    TranslateModule.forRoot({
      defaultLanguage: 'pe',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    TranslateService,
    {
      provide: 'googleTagManagerId',
      useValue: environment.TAG_MANAGER_CONTAINER_ID,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SecurityInterceptor,
      multi: true,
    },
    ReCaptchaV3Service,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.CAPTCHA_SITE_KEY,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LocationEvaluationInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeIndexedDB,
      deps: [IndexDBService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private navigationService: NavigationService) {}
}
